import {
  quoteItemChangeReviewSchema,
  type QuoteItemChangeReview as Review,
} from './quoteReviewContract';

/** Presenter key → the only command that card may carry. */
const LINE_CHANGE_PRESENTERS: Readonly<Record<string, 'update' | 'remove'>> = {
  'confirmation.presenters.updateQuoteItem': 'update',
  'confirmation.presenters.removeQuoteItem': 'remove',
};

export type ParsedQuoteItemChange =
  | { kind: 'absent' }
  | { kind: 'invalid' }
  | { kind: 'review'; review: Review };

/**
 * A quote line change is confirmable only with its complete server-built
 * review (#2546): a missing, malformed, mismatched or closed-quote review must
 * never become a headline-only affirm.
 */
export function parseQuoteItemChangeReview(
  params: Record<string, unknown>,
  presenterKey?: string
): ParsedQuoteItemChange {
  const action = Object.hasOwn(LINE_CHANGE_PRESENTERS, presenterKey ?? '')
    ? LINE_CHANGE_PRESENTERS[presenterKey ?? '']
    : undefined;
  if (!('quoteItemChangeReview' in params)) return action ? { kind: 'invalid' } : { kind: 'absent' };
  const parsed = quoteItemChangeReviewSchema.safeParse(params.quoteItemChangeReview);
  if (!parsed.success || !action || parsed.data.command.action !== action) return { kind: 'invalid' };
  const { quote, result } = parsed.data;
  if (
    quote.status !== 'quote' ||
    quote.isDisputed ||
    result.pricing.grossTotalCents !== result.pricing.netSubtotalCents + result.pricing.taxCents
  )
    return { kind: 'invalid' };
  return { kind: 'review', review: parsed.data };
}
